import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  height: 100%;

  .css-2b097c-container {
    background: transparent;
    flex: 1;
    height: 100%;
    display: flex;

    &,
    .react-select__control,
    .react-select__value-container,
    .css-1g6gooi {
      height: 2.4rem !important;
    }

    .react-select__control {
      flex: 1;
      cursor: pointer;
      border: 0;

      .react-select__value-container {
        .css-1uccc91-singleValue {
          color: var(--gray_light);
        }

        .react-select__input {
          padding-top: 0.2rem;

          input {
            height: 100%;
            text-transform: uppercase;
          }
        }
      }
    }

    .react-select__control--is-focused {
      border: 0;
      box-shadow: 0 0 0 transparent;
      border-width: 0;
    }

    .react-select__indicator-separator {
      display: none;
    }

    .react-select__dropdown-indicator {
      color: var(--primary_color);
    }

    .react-select__menu {
      margin-left: 0;
      padding: 0.8rem 0.4rem;

      .react-select__option {
        cursor: pointer;
        text-align: start;
        color: var(--gray);
      }

      .react-select__option--is-focused {
        color: var(--white);
      }
      .react-select__option--is-selected {
        color: var(--white);
        background: var(--primary_color);
      }

      .react-select__option + .react-select__option {
        margin-left: 0;
      }

      .react-select__menu-list {
        ::-webkit-scrollbar-track {
          background-color: transparent;
        }

        scrollbar-track-color: transparent;
        ::-webkit-scrollbar {
          width: 0.6rem;
          background: transparent;
        }
        ::-webkit-scrollbar-thumb {
          background: var(--primary_color);
          border-radius: 1rem;
        }

        scrollbar-base-color: var(--primary_color);
      }
    }
  }

  .react-select--is-disabled {
    width: 100%;

    .react-select__control {
      background: transparent;
      border: 0;
    }
  }

  @media (max-width: 768px) {
    select {
      font-size: 0.9rem;
      padding-right: 3rem;
      background-size: 0.6rem;
    }
  }

  @media (max-width: 520px) {
    select {
      font-size: 0.8rem;
    }
  }
`;
